<template>
  <section>
    <PageTitle>Opret ny global note</PageTitle>
    <section class="create-global">
      <Box>
        <CreateGlobalNotes @created="created" />
      </Box>
    </section>
  </section>
</template>

<script>
import Box from '../../components/Box.vue';
import CreateGlobalNotes from '../../components/Forms/GlobalNotes/CreateGlobalNotes.vue';

export default {
    name: 'CreateGlobalNote',
    components: { CreateGlobalNotes, Box },
    methods: {
        created(payload) {
            this.$router.push({
                name: 'global-notes.single',
                params: { id: payload.id },
                query: { date: window.moment.utc(payload.publishDate).local().format('YYYY-MM-DD HH:mm') },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.create-global {
    max-width: 400px;
}
</style>
